import ReactPaginate from 'react-paginate';
import { useState, useEffect } from 'react';

const Pagination = ({ totalPages, currentPage, handlePageChange }) => {
    const [isMobile, setIsMobile] = useState(false);

    // Check screen size for responsive pagination
    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // Use external isMobile prop if provided, otherwise use internal state
    const isMobileView = isMobile;

    return (
        <>
            {/* Pagination Section */}
            <div className="pagination-section">
                <button
                    className="pagination-first-button"
                    onClick={() => handlePageChange({ selected: 0 })}
                    disabled={currentPage === 1}
                >
                    &lt;&lt;
                </button>
                <ReactPaginate
                    pageCount={totalPages}
                    pageRangeDisplayed={isMobileView ? 5 : 10}
                    marginPagesDisplayed={0}
                    onPageChange={handlePageChange}
                    forcePage={currentPage - 1}
                    containerClassName="pagination-container"
                    pageClassName="pagination-page"
                    pageLinkClassName="pagination-link"
                    activeClassName="pagination-active"
                    previousClassName="pagination-nav"
                    nextClassName="pagination-nav"
                    previousLinkClassName="pagination-nav-link"
                    nextLinkClassName="pagination-nav-link"
                    previousLabel="&lt;"
                    nextLabel="&gt;"
                    breakClassName="pagination-break"
                    breakLinkClassName="pagination-break-link"
                    renderOnZeroPageCount={null}
                    disableInitialCallback={true}
                />
                <button
                    className="pagination-last-button"
                    onClick={() => handlePageChange({ selected: totalPages - 1 })}
                    disabled={currentPage === totalPages}
                >
                    &gt;&gt;
                </button>
            </div>
        </>
    )
}

export default Pagination;


